export default __webpack_public_path__ + "static/media/intern_sphere.728058bd.svg";